<template>
  <div>
    <b-spinner v-show="!isLoaded" label="Loading..." />
    <h1 v-if="requests.length === 0 && isLoaded">
      Keine offenen Anfragen vorhanden
    </h1>
    <b-list-group>
      <b-list-group-item
        :to="requestDetailsRoute + '/' + request.reqId"
        v-for="request in requests"
        :key="request.reqId"
        :variant="selectColorFor(request.statusId)"
        class="text-left text-md-center"
      >
        {{ request.citName }}
        -
        {{ request.disName }}
        -
        {{ request.reqRequesterStreet }}
        -
        {{
          request.reqChildbirthDate
            .split("-")
            .reverse()
            .join(".")
        }}
        -
        {{ request.reqRequesterName }}
        -
        {{
          request.insertedAt
            .split("-")
            .reverse()
            .join(".")
        }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { statusColorMixin } from "../mixins/statusColors";

export default {
  name: "RequestsList",
  mixins: [statusColorMixin],
  props: {
    requestApiPath: String,
    requestDetailsRoute: String
  },
  data() {
    return {
      requests: [],
      isLoaded: false
    };
  },
  mounted() {
    this.$http
      .get(this.requestApiPath)
      .then(response => (this.requests = response.data.data))
      .finally(() => (this.isLoaded = true));
  }
};
</script>

<style scoped></style>
